import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Voucher } from '@shared/models';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from '@shared/services';
import { TranslateService } from '@ngx-translate/core';
import { showSpinner } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class VoucherService {
  vouchers = new BehaviorSubject<Voucher[]>([]);

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}

  setVouchers(vouchers: Voucher[]): void {
    this.vouchers.next(vouchers);
  }

  getVouchersResponse(): Observable<Voucher[]> {
    return this.http.get<Voucher[]>('/api/invoice/v2/customer_portal/voucher/').pipe(
      catchError(() => {
        this.router.navigateByUrl('/dashboard');
        this.toastService.add({ type: 'error', message: this.translateService.instant('Common.Errors.PageCouldNotBeLoaded') });
        return of([]);
      }),
    );
  }

  redeemVoucher(code: string): Observable<Voucher> {
    return this.http.post<Voucher>('/api/invoice/v2/customer_portal/voucher/redeem/', { code }).pipe(showSpinner());
  }

}
